import { fromJS, Map, Set } from 'immutable';
import { deepMerge } from 'nike-ui/src/common/immutable/merge';

export const changeTicketusActiveMark = db => db.setIn(['ticketus', 'active', 'mark'], new Date().getTime());

export const ticketusActiveMatchLoaded = json => db => {
    const betIdsToPickIds = json.betIdsToPickIds || {};
    const iBetIdsToPickIds = Object.keys(json.betIdsToPickIds || {}).reduce((map, betId) => {
        return map.set(betId, Set(betIdsToPickIds[betId]));
    }, Map());
    return db
        .updateIn(['ticketus', 'active', 'match', 'betIdsToPickIds'], existing => deepMerge(existing, iBetIdsToPickIds))
        .updateIn(['ticketus', 'active', 'match', 'tickets'], existing => deepMerge(existing, fromJS(json.tickets)));
};

export const clearTicktusActiveMatch = db => db.deleteIn(['ticketus', 'active', 'match']);

export const ticketusActiveLoaded = json => db => {
    const prematchBoxIds = Set(Object.keys(json.prematchBoxToSportEvents));
    const prematchBoxToSportEvents = fromJS(json.prematchBoxToSportEvents);
    const resultsBoxIds = Set(Object.keys(json.resultsBoxToSportEvents));
    const resultsBoxToSportEvents = fromJS(json.resultsBoxToSportEvents);
    const sportEventIds = Set(Object.keys(json.sportEventToTickets));
    const sportEventToTickets = fromJS(json.sportEventToTickets);
    return db
        .updateIn(['ticketus', 'active', 'prematchBoxIds'], existing => deepMerge(existing, prematchBoxIds))
        .updateIn(['ticketus', 'active', 'prematchBoxToSportEvents'], existing =>
            deepMerge(existing, prematchBoxToSportEvents)
        )
        .updateIn(['ticketus', 'active', 'resultsBoxIds'], existing => deepMerge(existing, resultsBoxIds))
        .updateIn(['ticketus', 'active', 'resultsBoxToSportEvents'], existing =>
            deepMerge(existing, resultsBoxToSportEvents)
        )
        .updateIn(['ticketus', 'active', 'sportEventIds'], existing => deepMerge(existing, sportEventIds))
        .updateIn(['ticketus', 'active', 'sportEventToTickets'], existing => deepMerge(existing, sportEventToTickets));
};
